import { useEffect, useRef, useState } from 'react';

const SHOW_DELAY_MS = 400;
const MIN_DISPLAY_MS = 300;

/**
 * Delays skeleton appearance on fast loads and keeps it visible briefly
 * to avoid flash-of-content when data arrives quickly.
 */
export function useSkeletonVisibility(isLoading) {
  const [visible, setVisible] = useState(false);
  const shownAtRef = useRef(null);
  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    clearTimeout(showTimerRef.current);
    clearTimeout(hideTimerRef.current);

    if (isLoading) {
      showTimerRef.current = setTimeout(() => {
        shownAtRef.current = Date.now();
        setVisible(true);
      }, SHOW_DELAY_MS);
      return;
    }

    if (!shownAtRef.current) {
      setVisible(false);
      return;
    }

    const elapsed = Date.now() - shownAtRef.current;
    const remaining = Math.max(0, MIN_DISPLAY_MS - elapsed);

    hideTimerRef.current = setTimeout(() => {
      setVisible(false);
      shownAtRef.current = null;
    }, remaining);
  }, [isLoading]);

  useEffect(
    () => () => {
      clearTimeout(showTimerRef.current);
      clearTimeout(hideTimerRef.current);
    },
    [],
  );

  return visible;
}
